import Axios from 'axios'

const axios = Axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  headers: {
    'Access-Control-Allow-Origin': `${process.env.VUE_APP_API_URL}/api`,
    'access-control-allow-headers': 'Authorization',
  },
})

const getAllInfractions = async () => {
  return axios.request({
    method: 'GET',
    url: '/api/infractions',
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  })
}

const saveInfraction = async (data: Record<string, string>) => {
  return axios.request({
    method: 'POST',
    url: '/api/infractions',
    data,
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  })
}

const updateInfraction = async ({ id, ...data }) => {
  return axios.request({
    method: 'patch',
    url: `/api/infractions/${id}`,
    data: { id: id, ...data },
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  })
}

const deleteInfraction = async id => {
  return axios.request({
    method: 'DELETE',
    url: `/api/infractions/${id}`,
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  })
}

export default {
  getAllInfractions,
  saveInfraction,
  deleteInfraction,
  updateInfraction,
}
